module.exports = __webpack_public_path__ + "static/Gulp-e74ab39464d225ffc121ce3801a7945f.png";